<script>
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'normal',
      validator(value) {
        return [
          'normal',
          'theme',
        ].includes(value)
      },
    }
  },
  methods: {
    formatTextUpperCasefirst,
  }
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.baseSectionTitle, $style[`isStyle${formatTextUpperCasefirst(type)}`]]">
    <h2
      v-if="title"
      class="baseSectionTitle__title"
      v-html="title"
    ></h2>
    <p
      v-if="description"
      class="baseSectionTitle__description"
      v-html="description"
    ></p>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseSectionTitle {
  margin-bottom: 1.5rem;

  @include max-lg {
    margin-bottom: 1rem;
  }

  :global {
    .baseSectionTitle {
      &__title {
        margin-bottom: 0.25rem;
        font-size: 2rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-blue-dark;
        letter-spacing: 0.16em;

        @include max-lg {
          font-size: 1.5rem;
        }
      }

      &__description {
        margin-bottom: 0;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
      }
    }
  }

  &.isStyleTheme {
    :global {
      .baseSectionTitle {
        &__title {
          color: var(--color-blue-dark);
        }
      }
    }
  }
}
</style>
